<template>
  <v-container>
    <dependents-list />

    <v-btn dark fixed bottom right fab @click="create" color="accent" v-if="!isFecomercio">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import DependentsList from '@/components/dependents/DependentsList';

export default {
  data: () => ({

  }),
  computed: {
    isFecomercio() {
      return this.$store.getters['poweredBy/th'] === 'lnMQZ9bbUq';
    },
  },
  methods: {
    create() {
      this.$router.push({ name: 'dependents-cadastre' });
    },
  },
  components: {
    DependentsList,
  },
};
</script>
